<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <lib-ui-agency-form
    formControlName="agency"
    [states]="this.lookupStore.states() ?? []"
    [programs]="this.lookupStore.programs() ?? []"
  ></lib-ui-agency-form>
  <div class="ml-4">
    <h3>Other Options</h3>
    <div class="flex flex-row gap-4 w-full">
      <lib-form-dropdown
        class="w-1/2"
        label="Status"
        formControlName="status"
        [options]="this.lookupStore.agencyUserStatus() ?? []"
      >
      </lib-form-dropdown>
      <p class="flex items-center">Created Date: {{ this.agencyDetails()?.createDate | date }}</p>
    </div>
    <lib-button [type]="'submit'" [text]="'Update Company'"></lib-button>
  </div>
</form>
